module.exports = __webpack_public_path__ + "img/application-0.89ce9ce.png";